import { formatDate } from "@/i18n";

/** "November 1", or "January 1, 2027" when the year differs from `now`, in
 *  the app language. `timeZone: "UTC"` reads the date in UTC. */
export function longDate(iso: string, now: Date, timeZone?: "UTC"): string {
  const date = new Date(iso);
  const year = timeZone === "UTC" ? date.getUTCFullYear() : date.getFullYear();
  return formatDate(date, {
    month: "long",
    day: "numeric",
    ...(year !== now.getFullYear() ? { year: "numeric" } : {}),
    ...(timeZone ? { timeZone } : {}),
  });
}
